// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3xAEp","buttons":"Footer_buttons__15mzh"};